"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = formatPrice;
exports.centsToDollars = centsToDollars;
function formatPrice(price, shouldHideZeroCents = true) {
    const formattedPrice = centsToDollars(price).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const trimmedPrice = shouldHideZeroCents
        ? formattedPrice.replace(".00", "")
        : formattedPrice;
    return `$${trimmedPrice}`;
}
function centsToDollars(cents) {
    return cents / 100;
}
